$(document).ready(function() {
    $("form").each(function() {
        $(this).validate({
            ignore: null,
            rules: {
                name: {
                    required: true,
                    maxlength: 255,
                },
                email: {
                    required: true,
                    maxlength: 255,
                    email: true,
                },
                title: {
                    required: true,
                    maxlength: 255,
                },
                message: {
                    required: true,
                },
                hiddenRecaptcha: {
                    required: function () {
                        if (grecaptcha.getResponse() == '') {
                            return true;
                        } else {
                            return false;
                        }
                    }
                }
            },
            messages: {
                hiddenRecaptcha: {
                    required: "Please check the box below proceed"
                }
            },
            errorPlacement: function(error, element) {
                error.insertAfter(element);
            },
            errorElement: 'p',
            errorClass: 'formError',
        });
    });
});